import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { ONBOARDING_STATUS_NEEDS_PROFILE } from "../features/auth/userOnboardingStatus.js";

export default function ProtectedRoute({ children }) {
  const { currentUser, isGuest, onboardingStatus } = useAuth();

  if (!currentUser) {
    return <Navigate to="/auth" replace />;
  }

  // Guests get the full app without an account; they owe a profile only if they
  // decide to save their giftees.
  if (isGuest) {
    return children;
  }

  if (onboardingStatus === ONBOARDING_STATUS_NEEDS_PROFILE) {
    return <Navigate to="/auth" replace />;
  }

  return children;
}
